import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';

export type CaptchaValidationMessages = Pick<
  ValidationMessageSet,
  'requiredMessage'
>;

// Validation shared between client form & API payload
// Messages aren't needed for API payload validation
export const getBaseSchema = (messages?: CaptchaValidationMessages) =>
  z.object({
    // Calling it cToken in forms to try to obfuscate its purpose
    cToken: z.string().min(1, messages?.requiredMessage),
  });

// Validation for client form only
export const getCaptchaTokenSchema = getBaseSchema;
